<div class="mr-5">
    <a
        class="cursor-pointer inline-flex items-center justify-center"
        [matMenuTriggerFor]="menu"
        (menuClosed)="onMenuClosed()"
        (menuOpened)="onMenuOpened()">
        @if (securityService.meSignal()?.image) {
            <img
                alt="avatar"
                class="w-12 h-12 rounded-full flex items-center justify-center object-cover p-1"
                [class]="imageClasses()"
                [src]="securityService.meSignal()?.image" />
        } @else {
            <div
                class="w-12 h-12 rounded-full flex items-center justify-center"
                [class]="iconClasses()">
                <fa-icon
                    size="2xl"
                    [icon]="['fas', 'circle-user']" />
            </div>
        }
    </a>
    <mat-menu #menu="matMenu">
        <span
            class="p-4 font-base text-lg flex text-custom-extra-dark-grey"
            (click)="$event.stopPropagation()"
            >{{ securityService.meSignal()!.fullName }}</span
        >
        <button
            mat-menu-item
            (click)="openProfileModal()">
            <span>{{ 'myProfile' | transloco }}</span>
        </button>
        <button
            mat-menu-item
            (click)="openLogoutDialog()">
            <fa-icon
                class="mr-2"
                size="lg"
                [icon]="['fas', 'right-from-bracket']"
                [style.color]="'#363636'" />
            <span>{{ 'logout' | transloco }}</span>
        </button>
    </mat-menu>
</div>
